import { EffectCallback, useEffect } from 'react';

// eslint-disable-next-line react-hooks/exhaustive-deps
export const useOnMountEffect = (effect: EffectCallback): void => useEffect(effect, []);
